/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Min_Duration_LabelInputs */



/**
* | output |
* | --- |
* | "Minimum Event Duration (in seconds)" |
*
* @param {Style_Guide_Manager_Min_Duration_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_min_duration_label = /** @type {((inputs?: Style_Guide_Manager_Min_Duration_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Min_Duration_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Duree minimale d'evenement (en secondes)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Minimale Ereignisdauer (in Sekunden)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Durata minima dell'evento (in secondi)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Минимальная продолжительность события (в секундах)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Duración mínima del evento (en segundos)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("最短事件持续时间（秒）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最小イベント継続時間（秒）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("न्यूनतम आयोजन अवधि (सेकंड में)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Duração mínima do evento (em segundos)")
	return /** @type {LocalizedString} */ ("Minimum Event Duration (in seconds)")
});